import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'filter'
})

@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], value: string): any[] {
        console.log(value)
        if (!items) {
            return [];
        }
        if (!value) {
            return items;
        }
        //console.log(items)
        if(items[0]['username'] && items[0]['account_name'] && items[0]['country']){
            return items.filter(singleItem => singleItem['username'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['account_name'].toLowerCase().includes(value.toLowerCase()) || singleItem['country'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['account_name'] && items[0]['username']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['account_name'].toLowerCase().includes(value.toLowerCase()) || singleItem['username'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['username'] && items[0]['emailid']){
            return items.filter(singleItem => singleItem['username'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['emailid'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['username']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['username'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['username'] && items[0]['type']){
            return items.filter(singleItem => singleItem['username'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['type'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['type'] && items[0]['account_name']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['type'].toLowerCase().includes(value.toLowerCase()) || singleItem['account_name'].toLowerCase().includes(value.toLowerCase()));
        }
        
        if(items[0]['account_name'] && items[0]['username'] && items[0]['country']){
            return items.filter(singleItem => singleItem['account_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['username'].toLowerCase().includes(value.toLowerCase()) || singleItem['country'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['account_name'] && items[0]['username']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['account_name'].toLowerCase().includes(value.toLowerCase()) || singleItem['username'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['username'] && items[0]['emailid']){
            return items.filter(singleItem => singleItem['username'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['emailid'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['username']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['username'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['username'] && items[0]['type']){
            return items.filter(singleItem => singleItem['username'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['type'].toLowerCase().includes(value.toLowerCase()));
        }

        if(items[0]['project_name'] && items[0]['type'] && items[0]['account_name']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()) ||  singleItem['type'].toLowerCase().includes(value.toLowerCase()) || singleItem['account_name'].toLowerCase().includes(value.toLowerCase()));
        }
        
        if(items[0]['project_name']){
            return items.filter(singleItem => singleItem['project_name'].toLowerCase().includes(value.toLowerCase()));
        }

        // return items.filter(singleItem => singleItem[field].toLowerCase().includes(value.toLowerCase()) ||  singleItem[field1].toLowerCase().includes(value.toLowerCase()));
    }
}


// WEBPACK FOOTER //
// ./src/app/filter.pipe.ts